import { render } from "./founder-talent-top.vue?vue&type=template&id=6024c71b&ts=true"
import script from "./founder-talent-top.vue?vue&type=script&lang=ts"
export * from "./founder-talent-top.vue?vue&type=script&lang=ts"

import "./founder-talent-top.vue?vue&type=style&index=0&id=6024c71b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__